import { render, staticRenderFns } from "./premium-heart.vue?vue&type=template&id=8c705fe2&scoped=true"
import script from "./premium-heart.vue?vue&type=script&lang=js"
export * from "./premium-heart.vue?vue&type=script&lang=js"
import style0 from "./premium-heart.vue?vue&type=style&index=0&id=8c705fe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c705fe2",
  null
  
)

export default component.exports